<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
  <g clip-path="url(#un-pinned__a)">
    <path d="M1.66 2.54a1.033 1.033 0 0 0-1.442.174c-.35.441-.27 1.082.176 1.43l21.946 17.57c.445.349 1.09.268 1.442-.173.35-.441.27-1.082-.176-1.43l-4.628-4.04a1.36 1.36 0 0 0 1.052-.564c.257-.352.33-.81.188-1.221l-.042-.127a7.143 7.143 0 0 0-3.4-4.017l-.488-7.428h1.374c.757 0 1.369-.606 1.369-1.357A1.363 1.363 0 0 0 17.662 0H6.378A1.36 1.36 0 0 0 5.01 1.357c0 .75.612 1.357 1.37 1.357h1.48L7.6 7.229 1.66 2.54Zm10.624 13.531-6.322-4.936a7.085 7.085 0 0 0-1.989 3.024l-.043.127a1.34 1.34 0 0 0 .188 1.221 1.38 1.38 0 0 0 1.113.564h7.053Zm-1.578 1.358v5.214c0 .75.611 1.357 1.368 1.357.757 0 1.37-.607 1.37-1.357v-5.214h-2.738Z"/>
  </g>
  <defs>
    <clipPath id="un-pinned__a">
      <path d="M0 0h24v24H0z"/>
    </clipPath>
  </defs>
</svg>
